module.exports = __webpack_public_path__ + "img/err404.334fd576.png";